import { Skeleton } from '@/components/ui/skeleton';
import { TableSkeleton } from '@/components/ui/page-skeleton';

/** Podium cards then table rows, the shape of the loaded page. */
export function LeaderboardSkeleton() {
  return (
    <div className="space-y-6" aria-busy="true">
      <div className="grid gap-3 sm:grid-cols-3">
        {[0, 1, 2].map((i) => (
          <Skeleton key={i} className="h-[72px] rounded-lg bg-muted/40 sm:h-[148px]" />
        ))}
      </div>
      <TableSkeleton rows={8} columns={3} />
    </div>
  );
}
